import { render } from "./SobikSudyalar.vue?vue&type=template&id=1818d66a"
import script from "./SobikSudyalar.vue?vue&type=script&lang=js"
export * from "./SobikSudyalar.vue?vue&type=script&lang=js"

import "./SobikSudyalar.vue?vue&type=style&index=0&id=1818d66a&lang=css"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__